const passwordLength = 8;

export default {
    maxPay: v => v < 3000 || 'Max. 3000',
    required: v => !!v || 'This field is required',
    requiredArray: v => v && v.length > 0 || 'Choose at least 1 of the options',
    requiredSelect: val => val && val > -1 || 'Item is required',
    email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    date: v => /^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/.test(v) || `Enter a valid date (MM/DD/YYYY)`,
    password: v => v && v.length >= passwordLength || `Please enter at least ${passwordLength} characters`,
    password2: v => v && v.length >= passwordLength || `Please enter at least ${passwordLength} characters`,
    postalCode: v => v && v.length >= 5 || `Enter a valid ZIP code`,
    //phone: v => /^[0-9]{1}\s\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/.test(v) || `Enter a valid phone`,
    //phone: v => /^[0-9]{3}-[0-9]{2}-[0-9]{2}$/.test(v) || `Enter a valid phone`,
    phone: v => /^[0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2}$/.test(v) || `Enter a valid phone`,
    cardNumber: v => /^[0-9]{4}\s[0-9]{4}\s[0-9]{4}\s[0-9]{4}$/.test(v) || `Enter a valid card number`,
    cvv: v => v && v.length === 3 || `Enter a valid cvv/cvc number`,
    max255: v => !v || (v && v.length <= 255) || 'Max. 255 symbols'
}